__turbopack_context__.v({
  "content": "_xUaDW_content",
  "ctaButton": "_xUaDW_ctaButton",
  "title": "_xUaDW_title",
});
